((() => {
  let e = document.querySelector("#faq-container");
  if (void 0 !== e && null != e) {
    let a = e.querySelectorAll(".faq-item");
    function t(e) {
      let t = "rotate-180",
        o = "active",
        n = "hidden";
      (a.forEach((e) => {
        (e.classList.remove(o),
          e.querySelector(".faq-item__icon").classList.add(t),
          e.querySelector(".faq-item__answear").classList.add(n));
      }),
        e.classList.contains(o)
          ? (e.classList.remove(o),
            e.querySelector(".faq-item__icon").classList.add(t),
            e.querySelector(".faq-item__answear").classList.add(n))
          : (e.classList.add(o),
            e.querySelector(".faq-item__icon").classList.remove(t),
            e.querySelector(".faq-item__answear").classList.remove(n)));
    }
    (t(a[0]),
      a.forEach((e) => {
        e.querySelector(".faq-item__question").addEventListener(
          "click",
          (a) => {
            (a.preventDefault(), t(e));
          },
        );
      }));
  }
})(),
  "facebook_ad" ===
    new URLSearchParams(new URL(window.location.href).search).get("source") &&
    window.location.replace("https://maszynadodpf.pl#uzyskaj-oferte"),
  window.addEventListener("init", () => {
    document.querySelectorAll("video").forEach((e) => {
      e.play();
    });
  }),
  (() => {
    let e = document.querySelector("#navigation-bar"),
      t = document.querySelector(".js-cta-button");
    function a() {
      window.scrollY > 100
        ? (e.classList.add("bg-neutral-950"),
          t.classList.remove("translate-y-full"))
        : (e.classList.remove("bg-neutral-950"),
          t.classList.add("translate-y-full"));
    }
    (window.addEventListener("load", a), window.addEventListener("scroll", a));
  })(),
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('a[href^="#"]').forEach((e) => {
      e.addEventListener("click", function (e) {
        e.preventDefault();
        let t = this.getAttribute("href").substring(1),
          a = document.getElementById(t);
        if (a) {
          let e = a.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: e, behavior: "smooth" });
        }
      });
    });
}));